import { createContext, useContext } from 'react';
// added any to list here because enums were causing errors
// - would be great to fix underlying issue.
const ConversationStoreContext = createContext(null);
export const ConversationStoreProvider = ConversationStoreContext.Provider;
export const useConversationStore = () => {
    const conversationStore = useContext(ConversationStoreContext);
    if (!conversationStore) {
        // airbrake.notify('Store cannot be null');
        throw new Error('ConversationStore cannot be null, please add a context provider.');
    }
    return conversationStore;
};
//# sourceMappingURL=ConversationStoreProvider.js.map